/**
 * Preferences JS
 */
export const Preferences = (function () {

        var eventListeners = function () {
                $('.select-save #save').on('click', function (e) {
                        e.preventDefault();
                        if (Preferences.provisioned === false){
                                preferences.writePreferences();
                        }else{
                                preferences.updatePreferences();
                        }   
                });

                if ($('#select-interests').length) {
                        preferences.buildPreferences('hobbies_interests');
                }

                $('.select-preferences').on('click', function (e) {
                        preferences.showSubs(this.id);
                });
        }

        var provisioned = false;

        var preferences = {

                /** Uses the PDS function to get the preferences */
                buildPreferences : function (preferences_name) {

                        var dataset = 'ds_profiles_preferences'
                        PDS.pds.get(dataset).then(function (response) { 

                                if (response.length != 0){
                                        Preferences.provisioned = true
                                        var preferences = Preferences.preferences.extract(preferences_name,response);
                                        for (const iterator of preferences) {
                                          Preferences.preferences.build(iterator);
                                        }
                                }
                            
                        });
                },

                /** 
                 * Loops the Preferences and extracts the dataset that is passed as a parameter
                 * @returns a preferences []
                 * */
                extract : function (dataset, data, callable = null) {


                var result = [];
                for (var k in data) {

                        for (var v in data[k]) {

                          if (data[k][v] === dataset) {
                                  result.push(
                                    JSON.parse(data[k]['preference_content'])
                                  );
                          }
                        }
                }
                return result;
                },

                /** 
                 * Loops the Preferences and extracts the dataset that is passed as a parameter
                 * @returns a preferences []
                 * */
                extractTags : function (dataset, data) {

                  var preferences = this.extract(dataset, data)[0]

                  var tags = []
                  for (var key in preferences) {
                          
                          var value = preferences[key].selected;
                          // Add the category to the tags
                          if (value === true){
                                  //tags.push(key);
                          }

                          /** Get and parse the subcategories */
                          var sub_categories =  preferences[key]['sub_categories'];

                          for (var k in sub_categories) {
                          
                                  var selected = sub_categories[k];
                                  if(selected){
                                    tags.push(k);
                                  }
                          }

                  }
                  return tags; 
                },

                /**
                 * Function to load the retrieved preferences into the template with the member's choices
                 * TODO: refactor case statements and remove hard coded names
                 * @param {*} json_preferences 
                 */
                build : function (json_preferences) {

                  for (var key in json_preferences) {

                          var title = json_preferences[key].title;
                          var value = json_preferences[key].selected;
          
                          switch (title) {
                                  case 'Sports':
                                          document.getElementById('sports_header').checked = value;
                                          for (var k in json_preferences[key].sub_categories){
                                                  document.getElementById("sub-"+k).checked = json_preferences[key].sub_categories[k];
                                          }
                                          if (value === true){
                                                  this.showSubs('sports_header');
                                          }

                                          break;
                                  case 'Arts & Music':
                                          document.getElementById('arts_header').checked = value;
                                          for (var k in json_preferences[key].sub_categories){                                      
                                                  document.getElementById("sub-"+k).checked = json_preferences[key].sub_categories[k];
                                          }
                                          if (value === true){
                                                  this.showSubs('arts_header');
                                          }

                                          break;
                                  case 'Libraries':
                                          document.getElementById('libraries_header').checked = value;
                                          for (var k in json_preferences[key].sub_categories){
                                                  document.getElementById("sub-"+k).checked = json_preferences[key].sub_categories[k];
                                          }
                                          if (value === true){
                                                  this.showSubs('libraries_header');
                                          }
                                          break;
                                  case 'Communities':
                                          document.getElementById('communities_header').checked = value;
                                          for (var k in json_preferences[key].sub_categories){
                                                  document.getElementById("sub-"+k).checked = json_preferences[key].sub_categories[k];
                                          }
                                          if (value === true){
                                                  this.showSubs('communities_header');
                                          }
                                          break;
                                  case 'Museums':
                                          document.getElementById('museums_header').checked = value;
                                          for (var k in json_preferences[key].sub_categories){
                                                  document.getElementById("sub-"+k).checked = json_preferences[key].sub_categories[k];
                                          }
                                          if (value === true){
                                                  this.showSubs('museums_header');
                                          }
                                          break;
          
                                  default:
                                  // code block
                          }
                  }
                
                },

                /**
                 * Builds the list of profile and preferences to be written/provisioned into the member's PDS
                 */
                buildCategoryList() {

                  // Find all the top level catgerories
                  // We need to search each element for the checked value

                  var json = {
                          "arts": {
                                  "title": "Arts & Music",
                                  "selected": false,
                                  "sub_categories": {
                                          "Music": false,
                                          "Entertainment": false,
                                          "Dance": false,
                                          "Festivals": false,
                                          "Galleries": false,
                                          "Theatre": false,
                                          "Photography": false,
                                          "Comedy": false,
                                          "Pop Culture": false,
                                          "Sculpture": false
                                  }
                          },
                          "museums": {
                                  "title": "Museums",
                                  "selected": false,
                                  "sub_categories": {

                                          "Exhibitions": false,
                                          "Open day": false,
                                          "Tour": false
                                  }
                          },
                          "libraries": {
                                  "title": "Libraries",
                                  "selected": false,
                                  "sub_categories": {
                                          "Readings": false,
                                          "Signings": false,
                                          "Lending": false,
                                          "Computers": false,
                                          "Reference": false

                                  }
                          },
                          "sports": {
                                  "title": "Sports",
                                  "selected": false,
                                  "sub_categories": {
                                          "Football": false,
                                          "Rugby": false,
                                          "Tennis": false,
                                          "Badminton": false,
                                          "Cricket": false,
                                          "Gymnastics": false,
                                          "Swimming": false,
                                          "Squash": false,
                                          "Kayaking": false,
                                          "Cycling": false,
                                          "Running": false,
                                          "Jogging": false,
                                          "Walking": false
                                  }
                          },
                          "communities": {
                                  "title": "Communities",
                                  "selected": false,
                                  "sub_categories": {
                                          "Advice": false,
                                          "Cooking": false,
                                          "Education": false,
                                          "Social": false

                                  }
                          },
                          "well being": {
                                  "title": "Well Being",
                                  "selected": false,
                                  "sub_categories": {
                                          "support": false
                                  }
                          },
                  }


                  var id_array = ['communities_header', 'libraries_header', 'sports_header', 'museums_header', 'arts_header'];

                  for (var i = 0; i < id_array.length; i++) {
                          var el = document.getElementById(id_array[i]);

                          var sub = id_array[i].replace('_header', '');
                          // Set the selected state based on the checked value for each catergory
                          json[sub].selected = el.checked;

                          if (el.checked === true){
                                  for (var k in json[sub].sub_categories){


                                          json[sub].sub_categories[k] = document.getElementById('sub-'+k).checked;
                                  }
                          }
                  }

                  var string_json = JSON.stringify(json);

                  var preferences = {
                          "persona_name": 'Inclued',
                          "preference_name": "hobbies_interests",
                          "preference_content": string_json,
                          "preference_created_timestamp": Date.now(),
                          "preference_updated_timestamp": Date.now()
                  }

                  return preferences;

                },
                /**
                * Loads the preferences dataset from the PDS
                */
                loadPreferencesDataset() {

                  var dataset = 'ds_profiles_preferences'
                  var csrf = Util.getCSRF();
                  $.ajax({
                          url: 'pds-read',
                          type: 'post',
                          dataType: 'json',
                          data: {
                                  dataset: dataset,
                                  type: 'transactional'
                          },
                          headers: {'x-csrf-token': csrf }
                  }).done(function (response) { //
                          for (var k in response) {
                                  for (var v in response[k]) {
                                          if (response[k][v] === 'hobbies_interests') {

                                                  var preference_content = response[k]['preference_content'];
                                          }

                                  }
                          }

                  }).fail(function (e) {
                          console.log(e);
                  });

                },

                /**
                * Write an new transaction to profile and preferences - used on first time provisioning
                */
                writePreferences() {
                  var array = this.buildCategoryList();
                  var post_url = "/pds-write"; //get form action url
                  var csrf = Util.getCSRF();
                  return $.ajax({
                          url: post_url,
                          type: 'post',
                          data: {
                                  formData: array,
                                  dataset: 'ds_profiles_preferences',
                                  type: 'transactional'
                          },
                          headers: {'x-csrf-token': csrf }
                          }).fail(function (e) {
                                  console.log(e);
                                  return 'error';
                          });
                },
                /**
                * Updates/Saves the member selection to the PDS 
                */
                updatePreferences() {
                  var array = this.buildCategoryList();
                  var csrf = Util.getCSRF();
                  var post_url = "/pds-update"; //get form action url
                  $.ajax({
                          url: post_url,
                          type: 'post',
                          data: {
                                  data: array,
                                  dataset: 'ds_profiles_preferences',
                                  type: 'transactional',
                                  datasetID: 1
                          },
                          headers: { 'x-csrf-token': csrf },
                  }).done(function (response) { //
                          $("#save-success-alert").removeClass("d-none").fadeTo(2000, 500).slideUp(500, function() {
                                  $("#save-success-alert").slideUp(500);
                          });
                  }).fail(function (e) {
                          console.log(e);
                  });

                },

                /**
                 * function to show or hid sub categories
                 * paramter is the elemnt ID
                 * @param {*} id 
                 */
                showSubs(id) {

                  var res = id.split("_");
                  var sub_id =  res[0] + '_categories';

                  // If top level category is selected then show the sub categories
                  if (document.getElementById(id).checked === true) {
                    document.getElementById(sub_id).classList.remove("d-none");
                  } else {
                    document.getElementById(sub_id).classList.add("d-none");
                  }
                },

                openInNewTab(url) {
                  var win = window.open(url, '_blank');
                  win.focus();
                }
        }

    return {
        preferences:preferences,
        provisioned: provisioned,
        eventListeners: eventListeners
    }

}());

/**
 * Helper function used to generate formated sub categories
 * @param {*} k 
 * @param {*} category 
 */
function buildHelper(k, category){

    var div = document.createElement('div');
    div.setAttribute("class", "d-flex flex-row");
    var label = document.createElement('label');
    label.setAttribute("class", "consent-container");
     var input = document.createElement('input');
     var innerDiv = document.createElement('div');
     innerDiv.innerHTML = k;
     input.setAttribute("type", "checkbox");
     input.setAttribute("id", "sub-"+k)
     input.setAttribute("class", 'consent-slider');
     innerDiv.setAttribute("style", "margin-left: 15px;")

     div.appendChild(label);
     div.appendChild(innerDiv);
     label.appendChild(input);

     document.getElementById(category).style.display = "none";
     document.getElementById(category).appendChild(div);
}

